import { InsertionPosition } from "@redotech/redo-storefront-common/insertion-position";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const hsaPdpWidgetPlacementSchema_ = z.object({
  cssSelector: z.string(),
  insertionPosition: createEnum(InsertionPosition, {
    enumName: "InsertionPosition",
  }).optional(),
});

/** Where the "Pay with HSA/FSA" eligibility widget is placed on the storefront
 * product page. Mirrors the `settings.hsa.pdpWidgetPlacement` Mongoose subdoc. */
export const hsaPdpWidgetPlacementSchema: z.ZodType<HsaPdpWidgetPlacement> =
  hsaPdpWidgetPlacementSchema_;
export interface HsaPdpWidgetPlacement extends z.infer<
  typeof hsaPdpWidgetPlacementSchema_
> {}
